import { CellText } from "@design-system/DataGrid";
import { useScope } from "@state/scopeContext.lib";

/** A task's service or stage name, shown only on an organization's page. */
export const TaskCloseName = ({
    id,
    items,
}: {
    id: string;
    items: ReadonlyArray<{ id: string; name: string }>;
}) => {
    const { organizationId } = useScope();
    const name = items.find((item) => item.id === id)?.name;
    return organizationId && name ? (
        <CellText text={name} overflow="truncate" />
    ) : null;
};
